import template from './open-popup.vhtml';
import { i18n } from '../../translation.js';
import { historyComponentMixin } from '../../plugins/history';

export default {
	template,
	mixins: [ historyComponentMixin ],
	props: {
		popupType: {
			type: String,
			default: '',
		},
		popupData: {
			type: Object,
			required: true,
		},
		translationString: {
			type: String,
			default: 'signupForCourse',
		},
		urlParamName: {
			type: String,
			default: '',
		},
		isPopupActive: {
			type: Boolean,
			'default': false,
		},
		id: {
			type: String,
			default: null,
		},
	},
	data: () => ({}),
	computed: {
		urlParam() {
			return this.history.queryParams[ this.urlParamName ];
		},
	},
	watch: {
		id() {
			if ( this.id ) {
				this.history.setQueryParam( this.urlParamName, this.id );
			} else {
				this.history.setQueryParam( this.urlParamName, '' );
			}
		},
	},
	methods: {
		openPopup() {
			let popupData = {
				type: this.popupType,
				data: this.popupData,
			};
			this.$emit( 'update-popup', popupData );
		},
	},
	mounted() {
		if ( this.urlParam ) {
			this.openPopup();
		}
	},

};


// WEBPACK FOOTER //
// ./assets/_js/components/open-popup/open-popup.js